import { isInactive } from './isInactive'
import { BankingCard } from './types'

export const canReactivateCard = (card: BankingCard | null | undefined): boolean => {
  return card?._policies?.reactivate?.can === true && isInactive(card)
}
